import '@hotwired/turbo-rails'

// Font Awesome
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { library } from '@fortawesome/fontawesome-svg-core'
import '@fortawesome/fontawesome-free'
library.add(fas, far, fab)

// Vue
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createHead } from '@unhead/vue/client'
import router from '$/router.js'
import App from '&/App.vue'
import Notifications from '@kyvg/vue3-notification'
// import AppBreadcrumbs from '&/AppBreadcrumbs.vue'
import VueSafeHTML from 'vue-safe-html'
import { VueRecaptchaPlugin } from 'vue-recaptcha'
import AppAdSense from '&/adsense/AppAdSense.vue'

import '@/builds/tailwind.css'

document.addEventListener('turbo:load', () => {
  const app = createApp(App)
  const pinia = createPinia()
  const head = createHead()

  app.use(pinia)
  app.use(head)
  app.use(router)
  app.use(Notifications)
  app.use(VueSafeHTML)
  // app.component('AppBreadcrumbs', AppBreadcrumbs)
  app.component('AppAdSense', AppAdSense)
  app.use(VueRecaptchaPlugin, {
    v2SiteKey: '6Lenp5UqAAAAABTk___RuZZPi8pJg65kao6VpC0s',
  })
  app.mount('#app')

  import('../channels')

  // ===== Sub-menu
  const submenuItems = document.querySelectorAll('.submenu-item')
  submenuItems.forEach((el) => {
    el.querySelector('a').addEventListener('click', () => {
      el.querySelector('.submenu').classList.toggle('hidden')
    })
  })
})

// cropperjs must be last
import 'cropperjs/dist/cropper.min.js'
import 'cropperjs/dist/cropper.min.css'
